import { render, staticRenderFns } from "./mDriveRegistration.vue?vue&type=template&id=b5045ff0&scoped=true&"
import script from "./mDriveRegistration.vue?vue&type=script&lang=js&"
export * from "./mDriveRegistration.vue?vue&type=script&lang=js&"
import style0 from "./mDriveRegistration.vue?vue&type=style&index=0&id=b5045ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5045ff0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/mDrive/mDriveRegistration.vue
// module id = null
// module chunks = 